(function () {
  var MAX_FILES = 5;
  var MAX_BYTES = 10 * 1024 * 1024;
  var ALLOWED = {
    "image/jpeg": true,
    "image/png": true,
    "image/webp": true,
    "application/pdf": true,
  };

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function initUpload(root) {
    if (!root || root.dataset.cpiReady === "1") return;
    root.dataset.cpiReady = "1";

    var input = root.querySelector("[data-cpi-file]");
    var list = root.querySelector("[data-cpi-file-list]");
    var status = root.querySelector("[data-cpi-upload-status]");
    var urlsField = root.querySelector("[data-cpi-attachment-urls]");
    var namesField = root.querySelector("[data-cpi-attachment-names]");
    var dropzone = root.querySelector("[data-cpi-dropzone]");
    var form = root.closest("form");
    var submit = form && form.querySelector("[data-cpi-submit]");
    var proxy = root.getAttribute("data-proxy") || "/apps/petart";
    var files = [];

    function setStatus(message, isError) {
      if (!status) return;
      status.textContent = message || "";
      status.hidden = !message;
      status.classList.toggle("is-error", Boolean(isError));
    }

    function syncHidden() {
      if (urlsField) urlsField.value = files.map(function (f) { return f.url; }).join("\n");
      if (namesField) namesField.value = files.map(function (f) { return f.name; }).join(", ");
      if (input) input.setCustomValidity(files.length ? "" : "Please upload at least one image.");
      if (dropzone && files.length) dropzone.classList.remove("is-invalid");
    }

    function render() {
      if (!list) return;
      list.textContent = "";
      list.hidden = files.length === 0;
      files.forEach(function (item, index) {
        var li = document.createElement("li");
        li.className = "cpi__file-item";

        if (item.contentType && item.contentType.indexOf("image/") === 0) {
          var img = document.createElement("img");
          img.className = "cpi__file-thumb";
          img.src = item.url;
          img.alt = "";
          li.appendChild(img);
        } else {
          var badge = document.createElement("span");
          badge.className = "cpi__file-badge";
          badge.textContent = "PDF";
          li.appendChild(badge);
        }

        var meta = document.createElement("div");
        meta.className = "cpi__file-meta";
        var name = document.createElement("a");
        name.href = item.url;
        name.target = "_blank";
        name.rel = "noopener";
        name.textContent = item.name;
        var state = document.createElement("span");
        state.textContent = "Ready";
        meta.appendChild(name);
        meta.appendChild(state);
        li.appendChild(meta);

        var remove = document.createElement("button");
        remove.type = "button";
        remove.className = "cpi__file-remove";
        remove.textContent = "Remove";
        remove.addEventListener("click", function () {
          files.splice(index, 1);
          syncHidden();
          render();
        });
        li.appendChild(remove);
        list.appendChild(li);
      });
      syncHidden();
    }

    function validate(file) {
      if (!ALLOWED[file.type]) {
        return "Please choose a JPG, PNG, WebP, or PDF file.";
      }
      if (file.size > MAX_BYTES) {
        return "Each file must be smaller than 10 MB.";
      }
      return "";
    }

    function uploadFiles(fileList) {
      var incoming = Array.prototype.slice.call(fileList || []);
      if (!incoming.length) return;

      if (files.length + incoming.length > MAX_FILES) {
        setStatus("You can upload up to " + MAX_FILES + " files.", true);
        return;
      }

      for (var i = 0; i < incoming.length; i += 1) {
        var err = validate(incoming[i]);
        if (err) {
          setStatus(err, true);
          return;
        }
      }

      var body = new FormData();
      incoming.forEach(function (file) {
        body.append("file", file, file.name);
      });

      setStatus("Uploading…");
      if (submit) submit.disabled = true;

      fetch(proxy + "/inquiry-upload", {
        method: "POST",
        body: body,
        credentials: "same-origin",
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error((data && data.error) || "Upload failed.");
            return data;
          });
        })
        .then(function (data) {
          (data.files || []).forEach(function (file) {
            files.push(file);
          });
          setStatus(files.length ? files.length + " file(s) attached." : "");
          render();
        })
        .catch(function (error) {
          setStatus(error.message || "Upload failed. Please try again.", true);
        })
        .finally(function () {
          if (submit) submit.disabled = false;
          if (input) input.value = "";
        });
    }

    if (input) {
      input.addEventListener("change", function () {
        uploadFiles(input.files);
      });
      input.addEventListener("invalid", function () {
        if (dropzone) dropzone.classList.add("is-invalid");
        setStatus("Please upload at least one image of your design.", true);
      });
      syncHidden();
    }

    if (dropzone) {
      ["dragenter", "dragover"].forEach(function (name) {
        dropzone.addEventListener(name, function (event) {
          event.preventDefault();
          dropzone.classList.add("is-dragging");
        });
      });
      ["dragleave", "drop"].forEach(function (name) {
        dropzone.addEventListener(name, function (event) {
          event.preventDefault();
          dropzone.classList.remove("is-dragging");
        });
      });
      dropzone.addEventListener("drop", function (event) {
        var dropped = event.dataTransfer && event.dataTransfer.files;
        if (dropped && dropped.length) uploadFiles(dropped);
      });
    }

    function formValue(name) {
      var el = form && form.elements["contact[" + name + "]"];
      return el && el.value ? String(el.value).trim() : "";
    }

    function trackLead() {
      try {
        if (window.fbq) {
          window.fbq("track", "Lead", { content_name: "Custom Design Request" });
        }
      } catch (e) {}
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish("custom_inquiry_submitted", {
            product: formValue("product"),
          });
        }
      } catch (e2) {}
    }

    if (form) {
      form.addEventListener("submit", function (event) {
        if (form.dataset.cpiSending === "1") return;
        if (submit && submit.disabled) {
          event.preventDefault();
          setStatus("Please wait for uploads to finish.", true);
          return;
        }
        form.dataset.cpiSending = "1";
        trackLead();

        var payload = {
          firstName: formValue("first_name"),
          lastName: formValue("last_name"),
          email: formValue("email"),
          phone: formValue("phone"),
          description: formValue("body"),
          size: formValue("size"),
          variantId: formValue("variant_id"),
          color: formValue("desired_color"),
          attachmentUrls: formValue("attachment_urls"),
          product: formValue("product"),
          productUrl: formValue("product_url"),
        };

        // Let Shopify's contact form continue, including its spam check.
        // keepalive keeps the draft request alive if the page navigates.
        fetch(proxy + "/inquiry-submit", {
          method: "POST",
          credentials: "same-origin",
          keepalive: true,
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload),
        }).catch(function () {});
      });
    }
  }

  function initSize(root) {
    if (!root || root.dataset.cpiReady === "1") return;
    root.dataset.cpiReady = "1";

    var select = root.querySelector("[data-cpi-size-select]");
    var priceBox = root.querySelector("[data-cpi-price]");
    var priceValue = root.querySelector("[data-cpi-price-value]");
    var priceCompare = root.querySelector("[data-cpi-price-compare]");
    var variantField = root.querySelector("[data-cpi-variant-id]");
    var priceField = root.querySelector("[data-cpi-price-input]");
    if (!select) return;

    function sync() {
      var option = select.options[select.selectedIndex];
      var price = option && option.value ? option.getAttribute("data-price") || "" : "";
      var compare = price ? option.getAttribute("data-compare-price") || "" : "";
      if (variantField) variantField.value = price ? option.getAttribute("data-variant-id") || "" : "";
      if (priceField) priceField.value = price;
      if (priceValue) priceValue.textContent = price;
      if (priceCompare) {
        priceCompare.textContent = compare;
        priceCompare.hidden = !compare;
      }
      if (priceBox) priceBox.hidden = !price;
    }

    select.addEventListener("change", sync);
    sync();
  }

  ready(function () {
    document.querySelectorAll("[data-cpi-upload]").forEach(initUpload);
    document.querySelectorAll("[data-cpi-size]").forEach(initSize);
  });
})();
